import React, { useContext, useState } from "react";
import clsx from "clsx";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ListItems from "./listItems";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import AuthContext from "../../Context/autenticacion/authContext";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import {
  Box,
  Grid,
  Avatar,
  Hidden,
  Paper,
  Tooltip,
  Drawer,
  Divider,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CloseIcon from "@material-ui/icons/Close";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import Badge from "@material-ui/core/Badge";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  // Modern AppBar
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: "linear-gradient(50deg, #ce93d8 33%, #e1bee7 100%)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 2),
    minHeight: 64,
  },
  // Menu Button
  menuButton: {
    color: "#ffffff",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.2)",
      transform: "scale(1.05)",
    },
  },
  // Modern Drawer
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    background: "linear-gradient(55deg, indigo 33%, #3f51b5 100%)",
    border: "none",
    boxShadow: "4px 0 20px rgba(0, 0, 0, 0.2)",
  },
  // User Header in Drawer
  drawerHeader: {
    position: "relative",
    height: 180,
    backgroundImage: `url("https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=400&h=200&fit=crop")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  drawerHeaderOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0, 0, 0, 0.3)",
  },
  drawerHeaderContent: {
    position: "relative",
    zIndex: 1,
  },
  drawerUserInfo: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
  },
  drawerAvatar: {
    width: 56,
    height: 56,
    border: "2px solid rgba(255, 255, 255, 0.5)",
  },
  drawerUserType: {
    color: "#ffffff",
    fontSize: "0.875rem",
    fontWeight: 500,
    textShadow: "0 1px 2px rgba(0,0,0,0.3)",
  },
  drawerBranch: {
    color: "rgba(255, 255, 255, 0.9)",
    fontSize: "0.75rem",
    fontWeight: 400,
    textShadow: "0 1px 2px rgba(0,0,0,0.3)",
  },
  drawerUserName: {
    position: "relative",
    zIndex: 1,
    color: "#ffffff",
    fontSize: "1.1rem",
    fontWeight: 700,
    marginTop: theme.spacing(2),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textShadow: "0 2px 4px rgba(0,0,0,0.4)",
  },
  // Menu Items Container
  menuItemsContainer: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(1.5),
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(255,255,255,0.3)",
      borderRadius: "3px",
    },
  },
  // Logout Button
  logoutButton: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
    padding: theme.spacing(1.5, 2),
    color: "rgba(255, 255, 255, 0.9)",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
    cursor: "pointer",
    transition: "all 0.3s ease",
    background: "transparent",
    border: "none",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)",
      color: "#ffffff",
    },
  },
  logoutIcon: {
    width: 20,
    height: 20,
  },
  logoutText: {
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  // Logo
  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  logo: {
    height: 48,
    width: "auto",
    objectFit: "contain",
  },
  // User Section in AppBar
  userSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  userName: {
    color: "#ffffff",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  userAvatarWrapper: {
    position: "relative",
    cursor: "pointer",
  },
  userAvatar: {
    width: 40,
    height: 40,
    border: "2px solid rgba(255, 255, 255, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      border: "2px solid rgba(255, 255, 255, 0.6)",
    },
  },
  onlineIndicator: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: 12,
    height: 12,
    borderRadius: "50%",
    background: "#4caf50",
    border: "2px solid #ce93d8",
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: "50%",
      background: "#4caf50",
      animation: "$pulse 2s infinite",
    },
  },
  "@keyframes pulse": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
    },
    "50%": {
      transform: "scale(1.5)",
      opacity: 0,
    },
    "100%": {
      transform: "scale(1)",
      opacity: 0,
    },
  },
  // Modal Styles
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalCard: {
    maxWidth: 420,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 25px 50px rgba(0, 0, 0, 0.25)",
    outline: "none",
  },
  modalHeader: {
    background: "#ffffff",
  },
  modalMedia: {
    height: 0,
    paddingTop: "56.25%",
  },
  modalContent: {
    padding: theme.spacing(2),
  },
  modalActions: {
    padding: theme.spacing(1, 2),
    borderTop: "1px solid #e0e0e0",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatarContainer: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

// Styled Badge for online status
const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "2px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

export default function Dashboard() {
  const classes = useStyles();

  // Auth context
  const authContext = useContext(AuthContext);
  const { usuario, cerrarSesion } = authContext;

  // Drawer state
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Profile menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  // Expand card state
  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => setExpanded(!expanded);

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{
        style: {
          borderRadius: 8,
          marginTop: 8,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <MenuItem
        onClick={() => {
          handleOpenModal();
          handleMenuClose();
        }}
        style={{ fontSize: "0.875rem", padding: "10px 20px" }}
      >
        Mi cuenta
      </MenuItem>
      <MenuItem
        onClick={() => cerrarSesion()}
        style={{ fontSize: "0.875rem", padding: "10px 20px" }}
      >
        Cerrar sesión
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* Modern AppBar */}
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {/* Menu Button */}
          <IconButton
            className={classes.menuButton}
            onClick={handleDrawerOpen}
            edge="start"
          >
            <MoreVertIcon />
          </IconButton>

          {/* Logo - Hidden on mobile */}
          <Hidden only={["xs", "sm"]}>
            <Box className={classes.logoContainer}>
              <img
                src={require("../../assets/img/merry.png")}
                alt="Logo"
                className={classes.logo}
              />
            </Box>
          </Hidden>

          {/* User Section */}
          <Box className={classes.userSection}>
            <Hidden only={["xs"]}>
              <Typography className={classes.userName}>
                {usuario?.name}
              </Typography>
            </Hidden>
            <Box
              className={classes.userAvatarWrapper}
              onClick={handleProfileMenuOpen}
              aria-controls={menuId}
            >
              <Avatar
                alt="User"
                src={usuario?.image}
                className={classes.userAvatar}
              />
              <Box className={classes.onlineIndicator} />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Modern Drawer/Sidebar */}
      <Drawer
        className={classes.drawer}
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerClose}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {/* User Header */}
        <Box className={classes.drawerHeader}>
          <Box className={classes.drawerHeaderOverlay} />
          <Box className={classes.drawerHeaderContent}>
            <Box className={classes.drawerUserInfo}>
              <Avatar
                src={usuario?.image}
                className={classes.drawerAvatar}
              />
              <Box>
                <Typography className={classes.drawerUserType}>
                  {usuario?.type_user || "No Encontrado"}
                </Typography>
                <Typography className={classes.drawerBranch}>
                  {usuario?.branch || "No Encontrado"}
                </Typography>
              </Box>
            </Box>
            <Typography className={classes.drawerUserName}>
              {usuario?.name || "No Encontrado"}
            </Typography>
          </Box>
        </Box>

        {/* Menu Items */}
        <Box className={classes.menuItemsContainer}>
          <ListItems onItemClick={handleDrawerClose} />
        </Box>

        {/* Logout Button */}
        <Box
          component="button"
          className={classes.logoutButton}
          onClick={() => {
            cerrarSesion();
            handleDrawerClose();
          }}
        >
          <ExitToAppIcon className={classes.logoutIcon} />
          <Typography className={classes.logoutText}>
            Cerrar Sesión
          </Typography>
        </Box>
      </Drawer>

      {/* Account Modal */}
      <Modal
        disableEnforceFocus
        disableAutoFocus
        aria-labelledby="account-modal"
        className={classes.modal}
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <Card className={classes.modalCard}>
            <CardHeader
              className={classes.modalHeader}
              avatar={
                <Box className={classes.avatarContainer}>
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    variant="dot"
                  >
                    <Avatar alt="Foto Usuario" src={usuario?.image} />
                  </StyledBadge>
                </Box>
              }
              action={
                <Tooltip title="Cerrar">
                  <IconButton aria-label="Cerrar" onClick={handleCloseModal}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              }
              title={usuario?.name}
              subheader="Información de mi Cuenta"
            />
            <CardMedia
              className={classes.modalMedia}
              image={usuario?.image}
              title="Foto Usuario"
            />
            <CardContent className={classes.modalContent}>
              <Typography paragraph variant="body1" color="textSecondary">
                <strong>Nombre: </strong> {usuario?.name}
              </Typography>
              <Typography paragraph variant="body1" color="textSecondary">
                <strong>Tipo de Usuario: </strong> {usuario?.type_user}
              </Typography>
            </CardContent>
            <CardActions disableSpacing className={classes.modalActions}>
              <Tooltip title="Cambiar Contraseña">
                <IconButton
                  aria-label="Cambiar Contraseña"
                  href="/EditarContraseña"
                >
                  <LockOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Editar mi Cuenta">
                <IconButton aria-label="Editar mi Cuenta" href="/EditarPerfil">
                  <BorderColorOutlinedIcon />
                </IconButton>
              </Tooltip>
              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="Ver más"
              >
                <ExpandMoreIcon />
              </IconButton>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <CardContent className={classes.modalContent}>
                <Typography paragraph variant="body1" color="textSecondary">
                  <strong>Sucursal: </strong> {usuario?.branch}
                </Typography>
                <Typography paragraph variant="body1" color="textSecondary">
                  <strong>Email: </strong> {usuario?.email}
                </Typography>
              </CardContent>
            </Collapse>
          </Card>
        </Fade>
      </Modal>

      {renderMenu}
    </div>
  );
}
